import PageNotFoundTemplate from "../components/template/PageNotFoundTemplate"

const PageNotFound = () => {

  return (
    <PageNotFoundTemplate />
  )
}

export default PageNotFound